<template>
  <div class="property-selection">
    <h3 class="property-selection-title">
      Select property for AI to process
    </h3>
    <div class="property-selection-container">
      <div class="property-selection-container-item">
        <input
          id="house"
          v-model="type"
          type="radio"
          name="type"
          value="house"
          :checked="isChecked('house')">
        <label for="house">
          <div><img
            src="@/assets/img/order-steps/house-icon.svg"
            alt="house"></div>
          <p>House</p>
        </label>
      </div>
      <div class="property-selection-container-item">
        <input
          id="apartment"
          v-model="type"
          type="radio"
          name="type"
          value="apartment"
          :checked="isChecked('apartment')">
        <label for="apartment">
          <div><img
            src="@/assets/img/order-steps/plan-icon.svg"
            alt="apartment"></div>
          <p>Apartment</p>
        </label>
      </div>
      <div class="property-selection-container-item">
        <input
          id="other"
          v-model="type"
          type="radio"
          name="type"
          value="other"
          :checked="isChecked('other')">
        <label for="other">
          <div><img
            src="@/assets/img/order-steps/key-icon.svg"
            alt="another building"></div>
          <p>Another building</p>
        </label>
      </div>
    </div>
    <div class="property-selection-floors">
      <p class="property-selection-floors-text">
        The number of floors / apartments in the property
      </p>
      <label for="floors">{{ floorsCount }}</label>
      <input
        id="floors"
        value="1"
        type="number"
        name="floors"
        min="1"
        max="300">
      <img
        alt="up"
        src="@/assets/img/caret-up.svg"
        class="property-selection-floors-up"
        @click="addFloor">
      <img
        alt="down"
        class="property-selection-floors-down"
        src="@/assets/img/caret-down.svg"
        @click="removeFloor">
    </div>
    <button
      :class="{
        'btn-property-basic btn-form-selection-basic' : tariff === 1,
        'btn-property-plus btn-form-selection-plus' : tariff === 2,
        'btn-property-pro btn-form-selection-pro' : tariff === 3,
        'btn-property-render btn-form-selection-render' : tariff === 4,
        'btn-property-max btn-form-selection-max' : tariff === 6,
      }"
      class="order-modal-button"
      @click="next">
      Next
    </button>
  </div>
</template>

<script>
export default {
  name: 'PropertySelection',
  props: {
    defaults: {
      default: () => {},
      type: Object,
    },
    openNextStep: {
      default: () => null,
      type: Function,
    },
    saveTypeAndFloors: {
      default: () => null,
      type: Function,
    },
    tariff: {
      default: 1,
      type: Number,
    },
  },
  data: () => ({
    type: 'apartment',
    floorsCount: 1,
  }),
  mounted() {
    this.type = this.defaults.type;
    this.floorsCount = this.defaults.floorsCount;
  },
  methods: {
    next() {
      this.saveTypeAndFloors(this.type, this.floorsCount);
      this.openNextStep();
    },
    isChecked(type) {
      return this.type === type;
    },
    addFloor() {
      this.floorsCount += 1;
    },
    removeFloor() {
      if (this.floorsCount <= 1) return;
      this.floorsCount -= 1;
    },
  },
};
</script>
